import { render, staticRenderFns } from "./Checkup.vue?vue&type=template&id=2232d3a2&scoped=true&"
import script from "./Checkup.vue?vue&type=script&lang=js&"
export * from "./Checkup.vue?vue&type=script&lang=js&"
import style0 from "./Checkup.vue?vue&type=style&index=0&id=2232d3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232d3a2",
  null
  
)

export default component.exports